import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { AddCircleBlue, FullTable } from 'components';
import { PermissionList, RolePermission, useModal } from 'utils';
import { adminActions } from 'store';
import { timesheetBody, timesheetHead, TIMESHEET_ACTION_TYPE, staffTimesheetNotYet } from './constants';
import { CreateActiveTimesheet, MilageTimesheet, TIMESHEET_ENUMS, TimeSheetModalSelector } from '../../modals';
import { useLocation } from 'react-router-dom';

export const StaffTimesheet = ({}) => {
    const { staffTimesheet } = useSelector((state) => ({
        staffTimesheet: state.admins.timesheet,
    }));
    const dispatch = useDispatch();
    const { open } = useModal();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;

    const renderParams = () => {
        const pushInfo = {
            ...info,
        };
        delete pushInfo.page;
        delete pushInfo.activeTab;
        delete pushInfo.skip;
        delete pushInfo.limit;
        pushInfo.limit = 50;
        pushInfo.skip = info?.skip ? info?.skip : 0;
        return pushInfo;
    };

    useEffect(() => {
        if (info) {
            getTimesheet();
        }
    }, [info]);

    useEffect(() => {
        dispatch(adminActions.removeTimesheetById());
        return () => dispatch(adminActions.clearAllPayCodes());
    }, []);

    const getTimesheet = (load) => {
        dispatch(adminActions.getTimesheet(params.id, { ...renderParams() }, load));
    };

    const handleClick = (name, item) => {
        if (!item?.apptDisplayId) {
            if (item?.type === 'MILEAGE') {
                open(<MilageTimesheet info={item} fromStaff={true} />);
            } else {
                open(
                    <CreateActiveTimesheet
                        info={item}
                        type={item?.payCode?._id ? TIMESHEET_ENUMS.PAYCODE : TIMESHEET_ENUMS.FIXED}
                        fromStaff={true}
                    />
                );
            }
        }
    };

    const afterSuccess = () => {
        getTimesheet('noLoad');
    };

    return (
        <div>
            {RolePermission([PermissionList.STAFF_TIMESHEET_CREATE?.code]) && (
                <div className="header-action-btn">
                    <AddCircleBlue
                        type="button"
                        text={'Add Timesheet'}
                        handleClick={() => open(<TimeSheetModalSelector fromStaff={true} />)}
                    />
                </div>
            )}
            <FullTable
                margin={'0'}
                head={timesheetHead}
                body={timesheetBody(afterSuccess)}
                loadingType={TIMESHEET_ACTION_TYPE}
                handleClick={handleClick}
                // list={sortListByKey(staffTimesheet?.timesheets, 'displayId', info)}
                list={staffTimesheet?.timesheets}
                listCount={staffTimesheet?.count}
                notYet={staffTimesheetNotYet}
            />
        </div>
    );
};
